import { decorate, observable, action, runInAction } from 'mobx';
import WebApi, { getErrorMessage, getValidationErrors } from 'modules/WebApi';
//import { StoreInterface, RootStoreInterface } from 'interfaces';
import CommonStore from "modules/CommonStore";
import EmployeesAPI from "./api"

class employeesStore extends CommonStore {

  constructor(rootStore: RootStoreInterface) {
    const apiClient = new EmployeesAPI(rootStore.apiClient);

    super(
        rootStore,
        apiClient,
        rootStore.specifications["Employees"]
    );
  }



}


decorate(employeesStore, {

});



export default employeesStore;
